<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
    <div class="container">

        <!-- Cabeçalho -->
        <h1 class="title" style="margin: 24px 0;">Configurações</h1>

        <!-- ===== DADOS PESSOAIS ===== -->
        <section class="section-kits">
            <h2 class="title" style="font-size:20px;">Dados Pessoais</h2>

            <form [formGroup]="form" class="full-width" autocomplete="off" style="margin-top: 12px;">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="userName" placeholder="Seu nome completo" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Email</mat-label>
                    <input matInput [value]="userEmail" disabled />
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Telefone</mat-label>
                    <input matInput formControlName="mobilePhone" placeholder="(DDD) 9XXXX-XXXX" />
                </mat-form-field>
            </form>
        </section>

        <!-- ===== SEGURANÇA / SENHA ===== -->
        <section class="section-kits" style="padding-top: 8px;">
            <h2 class="title" style="font-size:20px;">Segurança</h2>

            <div class="form-grouped two-col">
                <!-- <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Nova senha</mat-label>
                    <input matInput type="password" placeholder="Digite sua nova senha" readonly
                        (focus)="openChangePasswordModal()" (click)="openChangePasswordModal()" />
                </mat-form-field> -->

                <div class="details-actions">
                    <button class="password-btn" (click)="openChangePasswordModal()">Alterar senha</button>
                </div>
            </div>
        </section>

        <!-- ===== CUPONS ===== -->
        <section class="section-kits" style="padding-top: 8px;">
            <h2 class="title" style="font-size:20px;">Cupons</h2>

            <!-- Lista de cupons -->
            <!-- Lista de cupons -->
            <div class="list-items" *ngIf="coupons?.length">
                <div class="list-card" *ngFor="let c of coupons; let i = index"
                    [ngClass]="{ 'coupon-active': c.isActive }">
                    <div class="kit-row">
                        <!-- Código -->
                        <mat-form-field appearance="fill" class="field">
                            <mat-label>Código cupom</mat-label>
                            <input matInput [(ngModel)]="c.couponCode" name="code{{i}}" [readonly]="!!c.idCoupon"
                                (keyup)="onCouponCodeInput(i)" />
                        </mat-form-field>

                        <!-- Percentual -->
                        <!-- Desconto (percentual ↔ valor) -->
                        <mat-form-field appearance="fill" class="field discount-field"
                            [floatLabel]="c._discountMode === 'value' ? 'always' : 'auto'">
                            <mat-label>Desconto</mat-label>

                            <!-- Percentual -->
                            <ng-container *ngIf="c._discountMode === 'percent'; else valueMode">
                                <input matInput type="number" min="0.01" max="100" step="0.01"
                                    [(ngModel)]="c.discountPercent" name="pct{{i}}" (input)="onPercentInput(i)" />
                                <!-- <span matSuffix>%</span> -->
                            </ng-container>

                            <!-- Valor (com prefixo R$) -->
                            <ng-template #valueMode>
                                <span matPrefix>R$&nbsp;</span>
                                <input matInput type="number" min="0.01" step="0.01" [(ngModel)]="c.discountValue"
                                    name="val{{i}}" (input)="onValueInput(i)" />
                            </ng-template>

                            <button mat-icon-button matSuffix class="discount-toggle"
                                [matTooltip]="c._discountMode === 'percent' ? 'Trocar para desconto em valor' : 'Trocar para desconto em percentual'"
                                (click)="toggleDiscountMode(i)">
                                <mat-icon>{{ c._discountMode === 'percent' ? 'percent' : 'attach_money' }}</mat-icon>
                            </button>
                        </mat-form-field>

                        <!-- Validade: fim (única exibida) -->
                        <mat-form-field appearance="fill" class="field">
                            <mat-label>Validade</mat-label>
                            <input matInput [matDatepicker]="pickerTo" [(ngModel)]="c.validTo" name="to{{i}}"
                                (dateChange)="onDateChange()" />
                            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                            <mat-datepicker #pickerTo></mat-datepicker>
                        </mat-form-field>

                        <!-- Ações -->
                        <div class="kit-actions">
                            <button class="btn-add" matTooltip="Adicionar cupom" (click)="addCoupon()">
                                <mat-icon>add</mat-icon>
                            </button>
                            <button class="btn-remove" matTooltip="Remover" (click)="removeNewCoupon(i)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button class="circle-icon-btn" [disabled]="!c.idCoupon"
                                matTooltip="Selecionar livros/kits para aplicar este cupom" (click)="openApplyModal(i)">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <button mat-icon-button class="circle-icon-btn"
                                [matTooltip]="c.isActive ? 'Desativar' : 'Ativar'" (click)="toggleCouponActive(i)">
                                <mat-icon [ngClass]="c.isActive ? 'icon-active' : 'icon-inactive'">
                                    {{ c.isActive ? 'visibility' : 'visibility_off' }}
                                </mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="kit-margin" style="margin-top:6px;">
                        <small>100% de desconto — serão cobrados somente custos de produção e envio.</small>
                    </div>

                    <div *ngIf="c._errors?.length" style="margin-top:8px;">
                        <small *ngFor="let e of c._errors" style="color:#c62828; display:block;">• {{ e }}</small>
                    </div>
                </div>
            </div>

            <!-- Estado vazio -->
            <div *ngIf="!coupons || coupons.length === 0" class="list-card">
                <div class="kit-row">
                    <mat-form-field appearance="fill" class="field">
                        <mat-label>Código cupom</mat-label>
                        <input matInput placeholder="Ex.: MEULIVRO10" />
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="field">
                        <mat-label>Percentual desconto</mat-label>
                        <input matInput type="number" placeholder="Ex.: 10" />
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="field">
                        <mat-label>Validade</mat-label>
                        <input matInput [matDatepicker]="pickerEmptyTo" />
                        <mat-datepicker-toggle matSuffix [for]="pickerEmptyTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerEmptyTo></mat-datepicker>
                    </mat-form-field>

                    <div class="kit-actions">
                        <button class="btn-add" matTooltip="Adicionar cupom" (click)="addCoupon()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="kit-margin" style="margin-top:6px;">
                    <small>100% de desconto — serão cobrados somente custos de produção e envio.</small>
                </div>
            </div>
        </section>

        <!-- ===== AÇÕES ===== -->
        <div class="details-actions">
            <button class="continue-btn" (click)="save()">Salvar Alterações</button>
        </div>

    </div>
</div>

<app-footer></app-footer>